import {
	AUTH_LOGGED_IN,
	AUTH_LOG_OUT,
	SET_AFTER_LOGIN,
	REMOVE_AFTER_LOGIN,
	UPDATE_USER_CREDIT,
	UPDATE_COMPANY_ONLINE,
	TOKEN_LOADING,
} from './actionTypes';

const initialState = {
	isLoggedIn: false,
	credit: 0,
	tokenLoading: false,
	profile: {
		mobile: null,
		gender: null,
		image: null,
		firstName: null,
		lastName: null,
		username: null,
		roles: null,
		userStateId: null,
	},
	addressList: [],
	company: {
		isSubsideOnFirstFoodItem: false,
		hasCredit: false,
		online: true,
		offlineText: '',
	},
	roles: {
		multiOrder: false,
	},
	afterLogin: {
		action: null,
		name: '',
		data: '',
	},
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case AUTH_LOGGED_IN:
			return {
				...state,
				profile: {
					...payload.profile,
					mobile: payload.profile.username,
				},
				addressList: payload.addressList,
				credit: payload.credit,
				// company: payload.company,
				company: {
					...payload.company,
					showPrice: false,
				},

				roles: {
					multiOrder: payload.profile.roles.indexOf(7) > -1,
				},
				isLoggedIn: true,
			};

		case AUTH_LOG_OUT:
			return initialState;
		case SET_AFTER_LOGIN:
			return {
				...state,
				afterLogin: payload,
			};
		case UPDATE_USER_CREDIT:
			return {
				...state,
				credit: payload,
			};
		case REMOVE_AFTER_LOGIN:
			return {
				...state,
				afterLogin: initialState.afterLogin,
			};
		case UPDATE_COMPANY_ONLINE:
			return {
				...state,
				company: {
					...state.company,
					...payload,
				},
			};
		case TOKEN_LOADING:
			return {
				...state,
				tokenLoading: payload,
			};
		default:
			return state;
	}
};
